<template>
  <el-dialog
    :id="$options.name"
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="退单弹窗"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div>确定退单吗?</div>
    <div slot="footer">
      <el-button @click="noDialog">取消</el-button>
      <el-button type="primary" @click="finish">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/mixin/dialogMixin";
import timeMixin from "@/mixin/timeMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import CarportMemberMonthlyLogController from "@/api/device/CarportMemberMonthlyLogController";
import { Message } from "element-ui";

export default {
  name: "refundCarportAndChargeMonthlyOrderDialog",
  mixins: [dialogMixin, timeMixin, resDisposeMixin],
  props: {
    orderObj: {
      type: Object,
      default: () => ({
        orderSn: undefined,
        orderType: undefined,
      }),
    },
  },
  watch: {
    orderObj: {
      handler(newValue) {
        // eslint-disable-next-line vue/no-mutating-props
        this.orderObj = newValue;
      },
      deep: true,
    },
  },
  methods: {
    finish() {
      this.loadStart();
      CarportMemberMonthlyLogController.agentUnsubscribeMonthlyOfCarportAndCharge(
        this.orderObj
      )
        .then((res) => {
          if (res.code === 1) {
            Message.success("退单成功~");
          }
          this.resNoDialog({ res });
        })
        .finally(() => {
          this.fetchNoDialog();
          this.loadDialog.close();
        });
    },
  },
};
</script>
